var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeJumpstart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "#e3fb94",
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.626 36.594c-.345 0-.635-.117-.868-.35s-.35-.524-.35-.869v-8.5c-1.3 0-2.55-.25-3.748-.747a9.697 9.697 0 01-3.17-2.118c-.913-.914-1.614-1.97-2.101-3.169s-.732-2.447-.732-3.747v-1.219c0-.345.117-.635.35-.868s.524-.35.869-.35h1.219c1.28 0 2.519.248 3.717.746a9.699 9.699 0 013.169 2.117c.63.63 1.152 1.32 1.569 2.072s.736 1.554.96 2.407c.101-.142.213-.28.335-.411.122-.132.254-.27.396-.411a9.695 9.695 0 013.169-2.118 9.677 9.677 0 013.747-.747h1.219c.345 0 .635.117.868.35s.35.524.35.87v1.218c0 1.3-.248 2.55-.746 3.748a9.697 9.697 0 01-2.117 3.168 9.539 9.539 0 01-3.154 2.103 9.74 9.74 0 01-3.732.731v4.875c0 .345-.117.635-.35.868s-.524.35-.869.35z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--jumpstart-27795238cfe5911eb6694af8848abb6e.svg";
export { SvgIconCircleLimeJumpstart as Component };